<div class="section-container">
  <div class="section-header">
    <div class="title-cont">
      <img src="/assets/icons/icon-compliance.svg" width="30" height="26" alt="Compliance Risk Icon" />
      <h2>Compliance Risk</h2>
    </div>
    <h3 class="sub-title">Measuring risk factors for the app developer’s compliance with data collection best practices,
      app store guidelines, and/or children’s privacy regulations.
    </h3>
  </div>

  <div class="sub-section critical" *ngIf="complianceOverview?.privacyPolicyRisk == 'Critical'">
    <div class="d-flex align-items-center ">
      <app-svg-icons [svg]="SVGS.iconWatch" [risk]="'critical'"></app-svg-icons>
      <h4 class="mr-auto">No Privacy Policy Detected</h4>
    </div>
  </div>
  <div class="sub-section low" *ngIf="complianceOverview?.privacyPolicyRisk == 'Low'">
    <div class="d-flex align-items-center ">
      <app-svg-icons [svg]="SVGS.iconWatch" [risk]="'low'"></app-svg-icons>
      <h4 class="mr-auto">Privacy Policy Detected</h4>
    </div>
  </div>

  <div class="sub-section" id="coppaViolationRisk">
    <ng-container *ngTemplateOutlet="affectedAppsTemplate; context: { 
        collapseId: 'coppaViolationRisk', 
        title: 'Children\'s Online Privacy Protection Act (COPPA) Violation Risk',
        tooltip: TOOLTIPS.coppaViolationRisk,
        risk: complianceOverview?.coppaViolationRisk,
        count: 0, 
        apps: [] }"></ng-container>
  </div>

  <div class="sub-section" id="vpcCoppaRisk">
    <ng-container *ngTemplateOutlet="affectedAppsTemplate; context: { 
        collapseId: 'vpcCoppaRisk', 
        title: 'Verifiable Parental Consent Not Detected',
        tooltip: TOOLTIPS.vpcCoppaRisk,
        risk: complianceOverview?.vpcCoppaRisk,
        count: complianceOverview?.vpcCoppaRiskCount, 
        apps: complianceOverview?.vpcCoppaRiskApps,
        icon: SVGS.parentalConsent }"></ng-container>
  </div>

  <div class="sub-section" id="locationPermissionRisk">
    <ng-container *ngTemplateOutlet="affectedAppsTemplate; context: { 
      collapseId: 'locationPermissionRisk', 
      title: 'Location Tracking Risk',
      tooltip: TOOLTIPS.locationPermissionRisk,
      risk: complianceOverview?.preciseLocationSurveillanceRisk,
      count: complianceOverview?.preciseLocationSurveillanceRiskCount, 
      apps: complianceOverview?.preciseLocationSurveillanceRiskApps,
      icon: SVGS.preciseLocation }"></ng-container>
  </div>

  <div class="sub-section" id="delistedAppRisk">
    <ng-container *ngTemplateOutlet="affectedAppsTemplate; context: { 
      collapseId: 'delistedAppRisk', 
      title: 'Banned Apps Risk',
      tooltip: TOOLTIPS.delistedAppRiskKyd,
      risk: complianceOverview?.delistedAppRisk,
      count: complianceOverview?.delistedAppRiskCount, 
      apps: complianceOverview?.delistedAppRiskApps,
      icon: SVGS.appStoreRemoval }"></ng-container>
  </div>

  <div class="sub-section" id="abandonedAppRisk">
    <ng-container *ngTemplateOutlet="affectedAppsTemplate; context: { 
      collapseId: 'abandonedAppRisk', 
      title: 'Security Risk',
      tooltip: TOOLTIPS.abandonedAppRisk,
      risk: complianceOverview?.abandonedAppRisk,
      count: complianceOverview?.abandonedAppRiskCount, 
      apps: complianceOverview?.abandonedAppRiskApps,
      icon: SVGS.abandonApps }"></ng-container>
  </div>
</div>

<ng-template #affectedAppsTemplate let-title="title" let-risk="risk" let-collapseId="collapseId" let-count="count"
  let-apps="apps" let-icon="icon" let-tooltip="tooltip">
  <div class="d-flex align-items-center">
    <app-svg-icons [svg]="icon || SVGS.iconWatch" [risk]="risk"></app-svg-icons>
    <h3 class="ml-1">{{ title }} <i class="fa fa-info-circle ml-2 tooltip-icon" *ngIf="tooltip" enTooltip
        [attr.title]="tooltip"></i>
    </h3>
    <risk-heat-meter class="ml-auto" version="v3" [risk]="risk"></risk-heat-meter>
  </div>

  <div class="nav-item" *ngIf="count > 0">
    <a class="btn btn-link affected-apps collapsed hasCount" data-toggle="collapse"
      href="#collapseExample{{collapseId}}" role="button" aria-expanded="false"
      aria-controls="collapseExample{{collapseId}}">
      Affected Apps ({{ count }})
    </a>
  </div>
  <div class="collapse" id="collapseExample{{collapseId}}" *ngIf="count > 0">
    <div class="d-flex flex-column">
      <ng-container *ngFor="let app of apps">
        <a class="btn btn-link btn-app mb-1 text-left"
          [routerLink]="['/insight/apps', app.appId, 'GLOBAL', app.appId | appStoreMap, 'GLOBAL']">
          <img src="{{ app?.appIcon }}" alt="{{ app?.appName }} Icon" class="mr-2 rounded" [attr.width]="'48'"
            [attr.height]="'48'" onerror="this.src='/assets/icons/icon-72x72-grey.png'" />
          <div class="appTitle">{{ app?.appName }}</div>
        </a>
      </ng-container>
    </div>
  </div>
</ng-template>